import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StaticContentType } from '../enums';
import { environment } from '../../../enviroments/environments';

export interface StaticContent {
  key: string;
  title: string;
  content: string;
}

// API response interface
export interface StaticContentResponse {
  [key: string]: string;
}

@Injectable({
  providedIn: 'root'
})
export class StaticContentService {
  private readonly baseUrl = `${environment.apiUrl}/static-content`;

  constructor(private readonly http: HttpClient) {}

  /**
   * Get all static content
   */
  getAllStaticContent(): Observable<StaticContentResponse> {
    return this.http.get<StaticContentResponse>(`${this.baseUrl}/all`);
  }

  /**
   * Get static content by type (key)
   * @param type - The content type/key from StaticContentType enum
   */
  getStaticContentByType(type: StaticContentType | string): Observable<StaticContent | null> {
    return this.http.get<StaticContentResponse>(`${this.baseUrl}/${type}`).pipe(
      map(response => {
        if (response?.[type]) {
          return {
            key: type,
            title: this.getDefaultTitle(type),
            content: response[type]
          };
        }
        return null;
      })
    );
  }

  private getDefaultTitle(key: string): string {
    const contentType = key.toUpperCase() as StaticContentType;
    
    switch (contentType) {
      // Company Section
      case StaticContentType.ABOUT: return 'About Us';
      case StaticContentType.CAREERS: return 'Careers';
      case StaticContentType.BLOG: return 'Blog';
      case StaticContentType.PARTNERS: return 'Our Partners';
      
      // Pages Section
      case StaticContentType.TEAM: return 'Our Team';
      case StaticContentType.PRICING: return 'Pricing Plans';
      case StaticContentType.GALLERY: return 'Gallery';
      case StaticContentType.SETTINGS: return 'Settings';
      case StaticContentType.PROFILE: return 'Profile';
      case StaticContentType.LISTINGS: return 'Listings';
      
      // Quick Links Section
      case StaticContentType.LEGAL: return 'Legal Notice';
      case StaticContentType.PRIVACY: return 'Privacy Policy';
      case StaticContentType.TERMS: return 'Terms and Conditions';
      case StaticContentType.REFUND: return 'Refund Policy';
      case StaticContentType.SUPPORT: return 'Chat Support';
      case StaticContentType.TICKETS: return 'Tickets';
      case StaticContentType.FAQ: return 'Frequently Asked Questions';
      
      // Default
      default: return key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();
    }
  }
}